// Import Libraries
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus } from '@fortawesome/free-solid-svg-icons';
import Tooltip from '@mui/material/Tooltip';

// Import Services
import utilities from '../../../services/utilities';

// Construct Component
const CollaboratorBubbleList = ({ collaborators, setShowCollabDropdown, level, activeList }) => {
  const [collabCount, setCollabCount] = useState(0);
  const [editorCount, setEditorCount] = useState(0);
  const [viewerCount, setViewerCount] = useState(0);

  // useEffect to count collaborators
  useEffect(() => {
    setCollabCount(collaborators.editors.length + collaborators.viewers.length + 1);
    setEditorCount(collaborators.editors.length);
    setViewerCount(collaborators.viewers.length);
  }, [collaborators]);

  // Helper function to determine background and text color based on activeList
  const getStyles = (collab) => {
    const isActive = activeList ? activeList.includes(collab.user_id) : true;
    return {
      backgroundColor: isActive ? collab.color || '#fff' : '#fff',
      color: isActive ? (utilities.isDarkColor(collab.color) ? 'white' : 'black') : 'black',
      border: isActive ? '1px solid transparent' : '1px solid #ccc',
      boxSizing: 'border-box',
      cursor: 'pointer',
    };
  };

  return (
    <>
      {collaborators && (
        <span className="FivePortionFlex Padded" style={{ marginTop: '5px' }}>
          &nbsp;
          {collaborators.owner && (
            <Tooltip title={collaborators.owner.email}>
              <span
                className="circleIcon userCircle popoverParent"
                style={{
                  ...getStyles(collaborators.owner),
                  position: 'relative',
                  zIndex: collabCount,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {collaborators.owner?.initials}
              </span>
            </Tooltip>
          )}
          &nbsp;
          {level === 'owner' && (
            <Tooltip title="Invite Collaborator" placement="top" arrow>
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginLeft: '8px',
                  marginTop: '5px',
                  float: 'right',
                  position: 'relative',
                  zIndex: collabCount + editorCount + viewerCount + 1,
                  cursor: 'pointer',
                }}
                onClick={() => setShowCollabDropdown(true)}
              >
                <FontAwesomeIcon
                  icon={faUserPlus}
                  style={{
                    fontSize: '20px',
                  }}
                />
              </span>
            </Tooltip>
          )}
          {collaborators.editors &&
            collaborators.editors.map((collab, editIndex) => (
              <Tooltip key={collab.id} title={collab.email}>
                <span
                  className="circleIcon userCircle popoverParent"
                  style={{
                    marginLeft: '-7px',
                    ...getStyles(collab),
                    position: 'relative',
                    zIndex: viewerCount + editIndex,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {collab.initials}
                </span>
              </Tooltip>
            ))}
          &nbsp;
          {collaborators.viewers.map((collab, viewIndex) => (
            <Tooltip key={collab.id} title={collab.email}>
              <span
                className="circleIcon userCircle popoverParent"
                style={{
                  marginLeft: '-7px',
                  ...getStyles(collab),
                  position: 'relative',
                  zIndex: viewIndex,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {collab.initials}
              </span>
            </Tooltip>
          ))}
        </span>
      )}
    </>
  );
};

export default CollaboratorBubbleList;
